import { cn } from '../lib/cn';

export interface SpinnerProps {
  /** Pixel diameter. 16 sits inside a button, 24 stands alone. */
  size?: number;
  /** Announced to screen readers. Pass `null` for a purely decorative spinner. */
  label?: string | null;
  className?: string;
}

/**
 * The one busy indicator. A stroked ring at `strokeWidth 2`, matching the funnel's
 * inline-SVG icon language (tokens doc §8.2), inheriting `currentColor` so it is the
 * right color inside a primary button and inside a page body alike.
 */
export function Spinner({ size = 16, label = 'Loading', className }: SpinnerProps) {
  return (
    <span
      className={cn('inline-flex shrink-0 items-center justify-center', className)}
      role={label === null ? undefined : 'status'}
      aria-hidden={label === null ? true : undefined}
      data-testid="spinner"
    >
      <svg
        className="animate-spin"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" opacity="0.25" />
        <path
          d="M22 12a10 10 0 0 0-10-10"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
      {label === null ? null : <span className="sr-only">{label}</span>}
    </span>
  );
}
